export { isNullOrEmpty, getBaseUrl, getReqParams, getAbsoluteUrl, normalizeUrl, startsWith, umlaute, isImage }


function normalizeUrl(u) {
    if( isNullOrEmpty(u) ) {
        return u;
    }
    if( !startsWith(u, '/') && !startsWith(u, 'http')) {
        u = '/' + u;
    }
    if( u.charAt( u.length-1) == '/' ) {
        u = u.substr(0, u.length-1);
    } 
    return u;
}

function getBaseUrl() {
    var baseUrl;
    // const key = 'baseurl';
    // var baseUrl = getItem(key);
    // if( !baseUrl ) {
        var pathArray = window.location.href.split( '/' );
        var protocol = pathArray[0];
        var host = pathArray[2];
        baseUrl = protocol + '//' + host;
       // setItem(key, baseUrl);
    // }
    return baseUrl;
}

function getReqParams() {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

function isNullOrEmpty(pString) {
    return null == pString || "" == pString || (typeof pString === 'undefined');
}

/*
function getItem(key) {
	var item = sessionStorage.getItem(key);
	if( isNullOrEmpty(item) ) return;
	// var itemJson = JSON.parse(item);
    // return itemJson;
    return item;
}

function setItem(key, val) {
    sessionStorage.setItem(key, val);
}
*/

function startsWith(haystack, needle) {
    if( haystack != null )
		return haystack.substring(0, needle.length) === needle;
	else 
		return 'empty';
}


// Maybe get comment here
function getAbsoluteUrl(album) {
    var url = getBaseUrl() + album;
    if(url.endsWith('#')) {
        return url.substring(0, url.length -1 );
    } else {
        return url;
    }
}


function umlaute(str) {
    var text = str;
    text = text.replace(/\\u00C4/g, "Ä");
    text = text.replace(/\\u00E4/g, "ä");
    text = text.replace(/\\u00D6/g, "Ö");
    text = text.replace(/\\u00F6/g, "ö");
    text = text.replace(/\\u00DC/g, "Ü");
    text = text.replace(/\\u00FC/g, "ü");
    text = text.replace(/\\u00DF/g, "ß");
    text = text.replace(/\\n/g, "<br>");
    return text;
}


function isImage(name) {
    const n = name.toLowerCase();
    return endsWith(n, ".jpg") || endsWith(n, ".jpeg") 
        || endsWith(n, ".png") || endsWith(n, ".gif");
}


function endsWith(pHaystack, pNeedle) {
    if( pNeedle.length > pHaystack.length ) return false;
    var haystack = pHaystack.toLowerCase();
    var needle = pNeedle.toLowerCase();
    return haystack.lastIndexOf(needle) == haystack.length - needle.length;
}
